import { ApiError, ResponseShapeError } from './api.js';

/** Human explanation for whatever a query or mutation threw. */
export function errorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const feature = error.notImplementedFeature;
    if (feature) return `The ${feature} API is not available in this build yet.`;
    if (error.status === 401) return 'Your session has expired. Sign in again.';
    if (error.status === 403) return 'You do not have permission to do this.';
    if (error.status === 404) return 'Not found.';
    return error.problem.detail ?? error.problem.title;
  }
  if (error instanceof ResponseShapeError) return error.message;
  if (error instanceof Error) return error.message;
  return 'Something went wrong.';
}

/** Field-level messages from an RFC 9457 validation problem. */
export function fieldErrorsOf(error: unknown): Record<string, string> {
  return error instanceof ApiError ? error.fieldErrors : {};
}

/**
 * The single input an RFC 9457 problem blamed with its `field` extension. The
 * API uses it for failures that are not shape problems (a wrong current
 * password, a taken email) and so carry no `errors` list.
 */
export function errorFieldOf(error: unknown): string | null {
  const field = error instanceof ApiError ? error.problem.field : undefined;
  return typeof field === 'string' ? field : null;
}

/** True when the failure is the API's "module not built yet" stub. */
export function isNotImplemented(error: unknown): boolean {
  return error instanceof ApiError && error.status === 501;
}
